import { queryOptions } from "@tanstack/react-query";
import { CachedQueryKeys } from "./cachedQueryKeys";
import { ThemeDraft } from "../../theme";
import { getAppTheme } from "../rest/appconfig";
import { APPID } from "@/utils/domain";

const getThemeQueryCacheKey = (appId: string) => {
  const themeCacheId = ThemeDraft.hasDraftId()
    ? `draft-${ThemeDraft.getCurrentId()}`
    : appId;
  return [CachedQueryKeys.AppTheme, themeCacheId];
};

export const appThemeQueryOptions = (appId: string = APPID) => {
  return queryOptions({
    queryKey: getThemeQueryCacheKey(appId),
    queryFn: async ({ signal }) => {
      if (!appId) {
        throw new Error("App ID is required to fetch app theme");
      }
      const theme =
        (await ThemeDraft.getTheme(appId, signal)) ??
        (await getAppTheme(signal));
      return theme;
    },
    // Use immediate updates
    staleTime: 0,
  });
};
